<script>
import { Pie } from "vue-chartjs";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
import { ChartJsPluginDataLabels } from "chartjs-plugin-labels"; // https://github.com/emn178/chartjs-plugin-labels

export default {
  components: {
    CustomTooltips,
    ChartJsPluginDataLabels
  },
  extends: Pie,
  props: ["data"],
  mounted() {
    // console.log(this.data);
    if (
      this.data.mode != undefined &&
      this.data.mode == "percentage" &&
      this.data.money == undefined
    ) {
      // console.log("percentage");
      this.renderChart(
        {
          labels: this.data.labels,
          datasets: this.data.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "percentage",
            precision: 1,
            // font size, default is defaultFontSize
            fontSize: 12,

            // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
            fontColor: "#ffffff"
          }
        }
      );
    } else if (
      this.data.mode != undefined &&
      this.data.mode == "percentage" &&
      this.data.money != undefined &&
      this.data.money == true
    ) {
      this.renderChart(
        {
          labels: this.data.labels,
          datasets: this.data.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "percentage",
            precision: 1,
            // font size, default is defaultFontSize
            fontSize: 12,

            // font color, can be color array for each data or function for dynamic color, default is defaultFontColor
            fontColor: "#ffffff"
          },

          tooltips: {
            enabled: true,
            callbacks: {
              label: function(tooltipItem, data) {
                let dataset = data.datasets[tooltipItem.datasetIndex];
                let currentValue = dataset.data[tooltipItem.index];
                let currentLabel = data.labels[tooltipItem.index];
                return currentLabel + ": $ " + formatPrice(currentValue);
              }
            }
          }
        }
      );
    } else {
      this.renderChart(
        {
          labels: this.data.labels,
          datasets: this.data.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "value"
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItems, data) => {
                // console.log(this)
                return "$ " + tooltipItems.yLabel;
              }
            }
          }
        }
      );
    }
  }
};
</script>
